import { render, staticRenderFns } from "./IconRggjjtzh.vue?vue&type=template&id=7d65572a"
import script from "./IconRggjjtzh.vue?vue&type=script&lang=js"
export * from "./IconRggjjtzh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports